const en_US = {
  "colorpicker.opacity-input": "Opacity",
  "datepicker.clear-date": "Clear date",
  "datepicker.apply-date-range": "Apply",
  "datepicker.next-month": "Next month",
  "datepicker.open-calendar": "Open calendar",
  "datepicker.previous-month": "Previous month",
  "input.clear": "Clear input",
  "input.hide-password": "Hide password",
  "input.show-password": "Show password",
  "modal.close": "Close",
  "multiselectchips.add-value": "Add ‘{value}’",
  "multiselectchips.remove-all": "Remove all",
  "pagination.next-page": "Next page",
  "pagination.previous-page": "Previous page"
};
export {
  en_US as default
};
//# sourceMappingURL=en_US.json.js.map
